import type { MultiValue } from 'react-select';
import type { SelectOptionInterface } from '@/components/atoms/MultiSelect/MultiSelect.interface';

/**
 * Tags the parent restaurant entry with `isFixed: true` so the MultiSelect
 * atom hides its remove handle and grays it out. Other entries keep `isFixed: false`.
 */
export const markParentRestaurantAsFixed = (
    list: MultiValue<SelectOptionInterface<number>>,
    parentRestaurantId: number | undefined,
): MultiValue<SelectOptionInterface<number>> =>
    list.map((restaurant) => ({
        ...restaurant,
        isFixed: restaurant.value === parentRestaurantId,
    }));

/**
 * Ensures the parent restaurant stays in the user's assigned list when MultiSelect
 * fires onChange — even if the entry was somehow removed (keyboard, paste, etc.).
 * If the parent is missing AND we know its label, it gets re-prepended as fixed.
 */
export const ensureParentRestaurantAssigned = (
    nextValue: MultiValue<SelectOptionInterface<number>>,
    parentRestaurantId: number | undefined,
    parentRestaurantLabel: string | undefined,
): MultiValue<SelectOptionInterface<number>> => {
    if (!parentRestaurantId || nextValue.some((r) => r.value === parentRestaurantId)) {
        return nextValue;
    }
    if (!parentRestaurantLabel) {
        return nextValue;
    }
    return [{ value: parentRestaurantId, label: parentRestaurantLabel, isFixed: true }, ...nextValue];
};
